import PropTypes from 'prop-types';
import React, { Component } from 'react';
import UserDetailsCard from 'components/users/UserDetailsCard';
import UploadsTable from 'components/UploadsTable';
import { connect } from 'react-redux';
import { ThemeProvider } from 'react-css-themr';
import { Tab, Tabs } from 'react-toolbox';
import theme from 'styles/resourceDetailsCard.scss';
import detailsCardElement from 'styles/detailsCardElement.scss';
import RTTabs from 'styles/tabs';
import InstallerCrewDetails from './installerCrewDetails';
import InstallerBasicInfoDetails from './installerBasicInfoDetails';
import InstallerCertificationsDetails from './installerCertificationsDetails';
import InstallerScore from './installerScore';
import { INSTALLER_TABS } from 'config/constants';
// import JobHistoryTable from 'components/JobHistoryTable';
import TimeOffTable from 'components/TimeOffTable';
import TravelingWorkTable from 'components/TravelingWorkTable';
import EmployableHistory from '../../../../../shared/components/EmployableHistory';
import Unauthorized from 'components/Unauthorized';
import PTOType from 'types/pto';
import { RoleType } from 'types/user';
import WorkroomType from 'types/workroom';
import { EditToggleButton } from 'components/EditableTable';
import helperStyle from './helperCard.scss';
import { can } from '../../../../../services';
import { roleNotInstallerBased } from '../../../../../utils';
import { permissionByWorkroomId } from '../../../../../utils/permissionUtils';
import { requestEmployee } from 'actionCreators';
import { getEmployeeById } from '../../../../../reducers';

const detailsTheme = {
  RTCard: theme, RTTabs, ResourceDetailsCE: detailsCardElement,
};

class InstallerDetails extends Component {
  constructor(props) {
    super(props);
    const { role } = props;
    const isInstallerSelf = role === 'installer';
    const hasIfiPermission = (props.mvw && props.mvw.ifi === true) || isInstallerSelf;
    this.state = {
      isEditable: false,
      allowedTabs: INSTALLER_TABS.filter((tab) => {
        if (tab.label === 'Millwork Certifications') {
          return hasIfiPermission && can(role, 'view', tab.ability);
        }
        return tab.label === 'Crew' || (roleNotInstallerBased(role) && can(role, 'view', tab.ability));
      }),
    };
  }

  componentDidMount = () => this.props.requestEmployee(this.props.user.employable_id);

  handleEditToggle = () => this.setState({ isEditable: !this.state.isEditable });

  renderCustomEditButton = (tab) => {
    const { role, user, installer } = this.props;
    const { isEditable } = this.state;
    if (!can(role, 'manage', 'pto', { user_id: user.id, obj_id: installer.id })) return null;
    let label;
    let style;
    if (tab === 'Time Off') {
      label = 'Edit Time Off';
      style = helperStyle.timeOffEditButton;
    } else {
      label = 'Edit Traveling Work';
      style = helperStyle.timeOffEditButton;
    }
    return (<EditToggleButton
      actionLabel={label}
      className={style}
      isEditable={isEditable}
      onClick={this.handleEditToggle}
    />);
  }

  renderTabContent = () => {
    const { installer, helpers, crews, crewsWorkrooms, crewsSurfaceTypes, activeTab,
            payRateUploadsData, ptos, travelingWorkDates, role } = this.props;
    const { isEditable, allowedTabs } = this.state;
    switch (allowedTabs[activeTab].label) {
      case 'Basic Info':
        return (<InstallerBasicInfoDetails
          installer={installer}
          theme={detailsTheme}
          role={role}
          position={this.props.position}
          mvw={this.props.mvw}
        />);
      case 'Millwork Certifications':
        return <InstallerCertificationsDetails installer={installer} />;
      case 'Scores':
        return <InstallerScore installer={installer} theme={detailsTheme} />;
      case 'Pay Rates':
        return (<div
          style={{
            padding: '15px 24px 15px 24px',
            borderBottom: 'solid 1px $line-divider-grey',
          }}
        >
          <UploadsTable
            role={role}
            isPayRate
            downloadColumnName="Download"
            data={payRateUploadsData}
            crews={crews.length ? crews : null}
          />
        </div>);
      case 'Crew':
        return (<InstallerCrewDetails
          helpers={helpers}
          crews={crews}
          crewsWorkrooms={crewsWorkrooms}
          crewsSurfaceTypes={crewsSurfaceTypes}
          role={role}
        />);
      case 'Time Off':
        return (<TimeOffTable
          isEditable={isEditable}
          ptos={ptos}
          parentID={installer.id}
          parentKind="installers"
          crews={crews}
          isCrew
        />);
      case 'Traveling Work':
        return (<TravelingWorkTable
          isEditable={isEditable}
          travelingWorkDates={travelingWorkDates}
          parentID={installer.id}
          parentKind="installers"
          crews={crews}
          isCrew
        />);
      case 'User Details History':
        return <EmployableHistory employable={installer} employableType={'installer'} />;
      default:
        return null;
    }
  }

  render = () => {
    const { installer, helpers, crews, workrooms, activeTab,
            onTabChange, role, employee = null } = this.props;
    const { allowedTabs } = this.state;
    const tabLabel = (allowedTabs[activeTab] || {}).label || '';
    const userProps = {
      user: installer,
      type: 'installers',
      role,
      workrooms,
      resource: 'installer',
      editAction: 'update_basic',
      editHandler: ['Time Off', 'Traveling Work'].includes(tabLabel) ? this.renderCustomEditButton(tabLabel) : null,
    };
    return (<ThemeProvider theme={detailsTheme}>
      {permissionByWorkroomId(role, workrooms, employee) ? (<UserDetailsCard {...userProps} >
        <Tabs index={activeTab} onChange={onTabChange} className={RTTabs.headerOnlyTabs}>
          {allowedTabs.map(tab => (<Tab key={tab.label} label={tab.label} />))}
        </Tabs>
        {this.renderTabContent(activeTab, installer, helpers, crews)}
      </UserDetailsCard>) : <Unauthorized restrictedItem="installer" />}
    </ThemeProvider>);
  }
}

InstallerDetails.propTypes = {
  activeTab: PropTypes.number,
  role: PropTypes.string,
  canEdit: PropTypes.bool,
  onTabChange: PropTypes.func,
  onSurfaceTypesChange: PropTypes.func,
  installer: PropTypes.object,
  helpers: PropTypes.array,
  crews: PropTypes.array,
  workrooms: PropTypes.arrayOf(WorkroomType),
  crewsWorkrooms: PropTypes.object,
  crewsSurfaceTypes: PropTypes.object,
  payRateUploadsData: PropTypes.array,
  ptos: PropTypes.arrayOf(PTOType),
  travelingWorkDates: PropTypes.array, // travelingWorkDates PropType?
  user: RoleType,
  requestEmployee: PropTypes.func,
  employee: PropTypes.object,
  position: PropTypes.string,
  mvw: PropTypes.object,
};

export default connect(state => ({
  employee: getEmployeeById(state)[state.user.employable_id],
  position: state.user.position,
  mvw: state.user.manage_vendor_workrooms || {},
}), { requestEmployee })(InstallerDetails);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/installers/components/installerDetailsCard.jsx